<div class="container">
  <h3 class="container-title" i18n>Add-ons</h3>
  <div class="addon-grid">
    <div class="addon-grid-item">
      <div class="addon-grid-icon">
        <img class="addon-grid-icon-img" src="assets/icons/ai-credits-icon.svg" width="32" height="32" alt="" />
      </div>
      <div class="addon-grid-info">
        <span class="addon-grid-count">{{ aiCreditsFormatted }}</span>
        <span class="addon-grid-description" i18n [class.nl]="locale === 'nl'" i18n>AI credits</span>
      </div>
    </div>
  </div>
</div>
